import { html } from 'lit';
import { classMap } from 'lit/directives/class-map.js';
import componentStyles from './paragraph.css.lit.ts';
import { OutlineElement } from '../../base/outline-element/outline-element.ts';

export default class Paragraph extends OutlineElement {
  static styles = [super.styles, componentStyles];
  static get properties() {
    return {
      bold: { type: Boolean },
      italic: { type: Boolean },
      small: { type: Boolean },
      legal: { type: Boolean },
      large: { type: Boolean },
      styleclass: { type: String },
    };
  }

  constructor() {
    super();
    this.type = '';
  }

  render() {
    const classes = classMap({
      'paragraph--bold': this.bold,
      'paragraph--italic': this.italic,
      'paragraph--small': this.small,
      'paragraph--legal': this.legal,
      'paragraph--large': this.large,
      [`paragraph--${this.styleclass}`]: this.styleclass,
    });

    return html`<p class="${classes}"><slot></slot></p>`;
  }
}

customElements.define('hf-paragraph', Paragraph);
